import { Injectable, inject } from '@angular/core';
import { DfEventService } from '@df/core/service/df-event';
import { GtmDlService } from '@df/module-gtm/service/gtm-dl.service';
import './gtm-event-provide-email';
import { CustomerModel } from '@df/session/api/customer.model';
@Injectable({
    providedIn: 'root'
})
export class GtmEventProvideEmailTrigger {
    /**
     * GTM service
     */
    private gtmService = inject(GtmDlService);
    /**
     * DF events service
     */
    private customerModel = inject(CustomerModel);
    /**
     * Setup event listener
     */
    constructor() {
        this.init();
    }
    /**
     * Setup event listener
     */
    private init() {
        this.customerModel.obs.email$.subscribe(email => {
            this.dispatch(email);
        });
    }
    /**
     * Dispatch event
     */
    private async dispatch(email: string | undefined) {
        return this.gtmService.dispatch({
            event: 'email_provided',
            providedEmail: email
        });
    }
}
